import { Flex } from '@chakra-ui/react';
import SidebarContent from './SidebarContent';
import { FunctionComponent } from 'react';

type SidebarProps = {
  onMenuClick: () => void;
};

const Sidebar: FunctionComponent<SidebarProps> = ({ onMenuClick }) => {
  return (
    <Flex
      direction='column'
      className='vertical-menu'
      shadow='sm'
      backgroundImage='linear-gradient(to top, neutral.100, neutral.200)'
    >
      <Flex height='70px' p='femto' align='center'>
        <button onClick={onMenuClick} type='button' className='btn btn-sm px-3 font-size-16 header-item' id='vertical-menu-btn'>
          <i className='fa fa-fw fa-bars' />
        </button>
      </Flex>

      <SidebarContent flexGrow={1} />
    </Flex>
  );
};

export default Sidebar;
